export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/nick-profile-f498136f09fda78a42de6c4f507083c0.png";